import type { OperationCosts } from '../../../services/operationCostsApi';

/**
 * O preço de UMA operação, lido do catálogo — e a ausência dele nunca vira 0.
 *
 * MEDIDO 2026-09-07: os cinco números da "Tabela de custos" do popover de
 * saldo eram escritos à mão, e um discordava do catálogo — a tela dizia
 * "Gerar Briefing: 5" contra `SDR_MEETING_PREP` com `credit_cost: 2`
 * (`janus-operations-management/deploy/seed_operations.py`). O mesmo 5
 * errado gateava o botão em `DealBriefing`, então quem tinha 3 créditos lia
 * "você não pode" para uma operação de 2.
 *
 * ── AS DUAS AUSÊNCIAS SÃO A MESMA RESPOSTA, E ELA NÃO É ZERO ────────────
 *
 * `null` quando o catálogo não respondeu (`costs === undefined`) E quando o
 * slug não está nele. As duas são "não sei quanto custa"; um `0` ali
 * afirmaria gratuidade que ninguém declarou — numa tela que se chama
 * "Tabela de custos", e num portão que decide se o botão pode ser clicado.
 * É o quinto zero fabricado desta base (saldo de créditos, preço negociado,
 * cota de assentos, tráfego do site, e agora o preço da operação).
 *
 * ── O COMPANHEIRO QUE IMPEDE O CONSERTO DE VIRAR O DEFEITO OPOSTO ───────
 *
 * `0` DECLARADO pelo catálogo é `0`, não ausência: o catálogo tem operações
 * `included` (`charge=false`), e engolir o zero delas esconderia justamente
 * o que é grátis. Por isso a leitura é `typeof === 'number'`, nunca uma
 * checagem de verdade (`costs[slug] || null` devolveria `null` para o 0).
 *
 * Função PURA de propósito: a regra é a mesma no popover (que exibe) e no
 * `DealBriefing` (que decide se o botão abre), e a única forma de as duas
 * telas nunca discordarem sobre o mesmo preço é uma regra com UM dono.
 * Mesma disciplina de `saldoDeCreditos` ao lado.
 */
export function custoDeOperacao(
  custos: OperationCosts | undefined,
  slug: string,
): number | null {
  const v = custos?.[slug];
  // `Number.isFinite` recusa `NaN`/`Infinity` — um payload torto viraria
  // "NaN créditos" na tela, que é pior que "—" porque parece uma medição.
  return typeof v === 'number' && Number.isFinite(v) ? v : null;
}

/** O que a tela mostra quando não sabe o preço. Nunca `0`, nunca vazio. */
export function textoDeCusto(custo: number | null): string {
  return custo === null ? '—' : String(custo);
}
